import React, { useEffect, useState } from 'react';
import { Building2, Users, BarChart2, TrendingUp } from 'lucide-react';
import api from '../../utils/api';

const fmt = (n) => (n == null ? '—' : n.toLocaleString('pt-BR'));
const fmtDate = (s) => s ? new Date(s).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '—';

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/dashboard').then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const kpis = [
    { label: 'Tenants ativos',    value: data?.kpis?.tenants_ativos,    icon: Building2,  color: 'bg-teal-50 text-teal-700' },
    { label: 'Total de tenants',  value: data?.kpis?.total_tenants,     icon: TrendingUp, color: 'bg-indigo-50 text-indigo-700' },
    { label: 'Usuários',          value: data?.kpis?.total_usuarios,    icon: Users,      color: 'bg-amber-50 text-amber-700' },
    { label: 'Simulações',        value: data?.kpis?.total_simulacoes,  icon: BarChart2,  color: 'bg-rose-50 text-rose-700' },
  ];

  return (
    <div>
      <h1 className="text-xl font-bold text-stone-900 mb-6">Dashboard</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {kpis.map(k => (
          <div key={k.label} className="bg-white border border-stone-200 rounded-xl p-4">
            <div className={`w-9 h-9 rounded-lg flex items-center justify-center mb-3 ${k.color}`}>
              <k.icon size={18} />
            </div>
            <p className="text-2xl font-bold text-stone-900">{loading ? '—' : fmt(k.value)}</p>
            <p className="text-xs text-stone-500 mt-0.5">{k.label}</p>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white border border-stone-200 rounded-xl overflow-hidden">
          <div className="px-5 py-4 border-b border-stone-100 font-semibold text-stone-800 text-sm">Tenants Recentes</div>
          {loading ? <div className="p-6 text-center text-stone-400 text-sm">Carregando...</div> : (
            <table className="w-full text-sm">
              <thead className="bg-stone-50 text-stone-500 text-xs">
                <tr><th className="text-left px-4 py-2">Nome</th><th className="text-left px-4 py-2">Tipo</th><th className="text-left px-4 py-2">Plano</th><th className="text-left px-4 py-2">Status</th></tr>
              </thead>
              <tbody className="divide-y divide-stone-50">
                {(data?.tenants_recentes || []).length === 0
                  ? <tr><td colSpan={4} className="px-4 py-6 text-center text-stone-400">Nenhum tenant</td></tr>
                  : (data?.tenants_recentes || []).map(t => (
                    <tr key={t.id}>
                      <td className="px-4 py-3 font-medium text-stone-800">{t.nome}</td>
                      <td className="px-4 py-3 text-stone-500 capitalize">{t.tipo}</td>
                      <td className="px-4 py-3 text-stone-500 capitalize">{t.plano}</td>
                      <td className="px-4 py-3"><span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${t.status === 'ativo' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>{t.status}</span></td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          )}
        </div>

        <div className="bg-white border border-stone-200 rounded-xl overflow-hidden">
          <div className="px-5 py-4 border-b border-stone-100 font-semibold text-stone-800 text-sm">Atividade Recente</div>
          {loading ? <div className="p-6 text-center text-stone-400 text-sm">Carregando...</div> : (
            <ul className="divide-y divide-stone-50">
              {(data?.atividade_recente || []).length === 0
                ? <li className="px-4 py-6 text-center text-stone-400 text-sm">Nenhuma atividade</li>
                : (data?.atividade_recente || []).map(l => (
                  <li key={l.id} className="px-4 py-3 flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-stone-800">{l.acao}</p>
                      <p className="text-xs text-stone-400">{l.ator_email || 'sistema'}</p>
                    </div>
                    <span className="text-xs text-stone-400 shrink-0 ml-3">{fmtDate(l.timestamp)}</span>
                  </li>
                ))
              }
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
